const KEYS = { owner: "cd_owner_token", teacher: "cd_teacher_token" };
const RKEYS = { owner: "cd_owner_refresh", teacher: "cd_teacher_refresh" };

export const portalFor = (pathname = window.location.pathname) =>
  /^\/teacher(-|$)/.test(pathname) ? "teacher" : "owner";

export const loginPathFor = (portal) => (portal === "teacher" ? "/teacher-login" : "/login");
export const homePathFor = (portal, role) =>
  portal === "teacher" ? "/teacher-dashboard" : role === "super_admin" ? "/super-admin" : "/dashboard";

// Legacy single-key sessions are moved to the role-specific key once.
(() => {
  const legacy = localStorage.getItem("cd_token");
  if (!legacy) return;
  const portal = localStorage.getItem("cd_role") === "teacher" ? "teacher" : "owner";
  if (!localStorage.getItem(KEYS[portal])) localStorage.setItem(KEYS[portal], legacy);
  localStorage.removeItem("cd_token");
  localStorage.removeItem("cd_role");
})();

// This tab's own session wins (lets two accounts of the same role live in two tabs);
// a fresh tab falls back to the most recent login for that portal.
export const getToken = (portal) => sessionStorage.getItem(KEYS[portal]) || localStorage.getItem(KEYS[portal]);
export const getRefreshToken = (portal) => sessionStorage.getItem(RKEYS[portal]) || localStorage.getItem(RKEYS[portal]);

export const setToken = (portal, token, refreshToken) => {
  sessionStorage.setItem(KEYS[portal], token);
  localStorage.setItem(KEYS[portal], token);
  if (refreshToken) {
    sessionStorage.setItem(RKEYS[portal], refreshToken);
    localStorage.setItem(RKEYS[portal], refreshToken);
  }
};

export const clearToken = (portal) => {
  const mine = sessionStorage.getItem(KEYS[portal]);
  sessionStorage.removeItem(KEYS[portal]);
  sessionStorage.removeItem(RKEYS[portal]);
  if (!mine || localStorage.getItem(KEYS[portal]) === mine) {
    localStorage.removeItem(KEYS[portal]);
    localStorage.removeItem(RKEYS[portal]);
  }
};

export const keyFor = (portal) => KEYS[portal];
